import React from "react";

const SpotlightContext =  React.createContext({});

export default SpotlightContext;
